import km from 'keymirror'
import _ from 'underscore'

export default _.extend({
  FENQILE_PAY_RESULT_SUCCESS: 'success', // 回调页支付成功标识
  FENQILE_PAY_RESULT_FAIL: 'fail', // ...失败标识
  FENQILE_CHECK_AMOUNT_URL: 'https://auth.fenqile.com/credit/index.html',
}, km({
  FENQILE_BINDFENQILEACCOUNT_SUCCESS: null,
  FENQILE_BINDFENQILEACCOUNT_ERROR: null,
  FENQILE_FENQILELOGIN_SUCCESS: null,
  FENQILE_FENQILELOGIN_ERROR: null,
  FENQILE_GETFENQILEPAYURL_SUCCESS: null,
  FENQILE_GETFENQILEPAYURL_ERROR: null,
  FENQILE_FENQILEPAYTRIAL_SUCCESS: null,
  FENQILE_FENQILEPAYTRIAL_ERROR: null,
  FENQILE_GETAPPTOKEN_SUCCESS: null,
  FENQILE_GETAPPTOKEN_ERROR: null,
    /*yeoman-template-point-1*/
}))
